module.exports = __webpack_public_path__ + "img/banner.de5596d0.png";